import React from "react";
import {
  FaShieldHalved,
  FaHeadset,
  FaWandMagicSparkles,
  FaTag,
} from "react-icons/fa6";
import { useTranslation } from "react-i18next";

type Feature = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

const features: Feature[] = [
  {
    title: "Trust & Security",
    description:
      "Fully accredited and bonded agency ensuring your investment is always protected.",
    icon: <FaShieldHalved />,
  },
  {
    title: "24/7 Concierge",
    description:
      "Round-the-clock support before, during, and after your luxury journey.",
    icon: <FaHeadset />,
  },
  {
    title: "Customized Packages",
    description:
      "Tailor-made itineraries designed specifically to match your unique preferences.",
    icon: <FaWandMagicSparkles />,
  },
  {
    title: "Best Price Guarantee",
    description:
      "Premium experiences curated to provide the absolute best value for your investment.",
    icon: <FaTag />,
  },
];

const WhyChoose: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-20 bg-brand-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-brand-pink text-sm font-semibold tracking-widest uppercase">
            {t("The GET2VACATIONS Difference")}
          </span>

          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brand-dark mt-2">
            {t("Why Choose Us")}
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white p-8 rounded-2xl text-center card-shadow hover:-translate-y-2 transition-transform duration-300"
            >
              <div className="w-16 h-16 mx-auto bg-brand-gray rounded-full flex items-center justify-center text-brand-pink text-2xl mb-6">
                {feature.icon}
              </div>

              <h3 className="font-bold text-lg mb-3">{t(feature.title)}</h3>

              <p className="text-brand-muted text-sm">
                {t(feature.description)}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyChoose;
